import React from "react";
import logo from "../../../images/logo.webp";
import d_banner from "../../../images/dg_banner.webp";
import dg1 from "../../../images/d_grace1.webp";
import dg2 from "../../../images/d_grace2.webp";
import dg3 from "../../../images/d_grace3.webp";
import dg4 from "../../../images/d_grace4.webp";
import dg5 from "../../../images/d_grace5.webp";
import dg6 from "../../../images/d_grace6.webp";
import dg7 from "../../../images/d_grace7.webp";
import dg8 from "../../../images/d_grace8.webp";
import dg9 from "../../../images/d_grace9.webp";
import dg10 from "../../../images/d_grace10.webp";
import dg11 from "../../../images/d_grace11.webp";
import dg12 from "../../../images/d_grace12.webp";
import dg13 from "../../../images/d_grace13.webp";
import dg14 from "../../../images/d_grace14.webp";
import dg15 from "../../../images/d_grace15.webp";
import dg16 from "../../../images/d_grace16.webp";
import dg17 from "../../../images/d_grace17.webp";
import dg18 from "../../../images/d_grace18.webp";
import dg19 from "../../../images/d_grace19.webp";
import dg20 from "../../../images/d_grace20.webp";
import dg21 from "../../../images/d_grace21.webp";
import { FaSearch } from "react-icons/fa";
import { IoBag } from "react-icons/io5";
import { FaRegHeart } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { FaBars } from "react-icons/fa6";
import { FaBell } from "react-icons/fa";

const DivineGrace = () => {
  return (
    <>
      <div className="bg-divine_secondary py-2">
        <div className="container mx-auto grid grid-cols-2">
          <div className="text-lg font-semibold">Today's Metal Rate</div>
          <div className="flex justify-end items-center text-lg font-semibold">
            Plan Your Investment
          </div>
        </div>
      </div>

      <div className="container mx-auto flex items-center justify-between py-4">
        <div className="flex items-center">
          <img className="w-64 h-24" src={logo} alt="img" />
        </div>

        <div className="flex-1 px-4">
          <div className="relative flex items-center justify-center w-full">
            <input
              type="text"
              placeholder="Search..."
              className="border border-gray-300 rounded-lg p-4 pr-12 w-2/3"
            />
            <FaSearch className="absolute right-40 mr-4 text-gray-400 bg-divine_primary p-2 w-14 h-full rounded text-white" />
          </div>
        </div>
        <div className="flex items-center">
          <div className="flex flex-col items-center mr-4">
            <IoBag className="text-[25px]" />
            <span className="text-md font-semibold">Cart</span>
          </div>

          <div className="flex flex-col items-center mr-4">
            <FaRegHeart className="text-[25px]" />
            <span className="text-md font-semibold">Wishlist</span>
          </div>

          <div className="flex flex-col items-center">
            <FaUser className="text-[25px]" />
            <span className="text-md font-semibold">Login</span>
          </div>
        </div>
      </div>

      <div className="bg-divine_secondary">
        <div class="container mx-auto text-md flex items-center space-x-8">
          <div class="flex items-center">
            <h1 class="bg-divine_primary text-white px-4 py-2 rounded flex items-center">
              <FaBars class="mr-2" />
              Categories
            </h1>
          </div>

          <ul class="list-none p-0 m-0 flex space-x-10 font-semibold">
            <li>Home</li>
            <li>About Us</li>
            <li>Contact Us</li>
            <li>Gold Plan</li>
          </ul>
        </div>
      </div>

      {/* End of Header Section */}

      <div className="">
        <img className="image" src={d_banner} alt="banner-image"></img>
      </div>

      {/* End of Banner Content */}

      <div className="flex justify-center text-2xl font-semibold my-7">
        The Timeless Beauty and Utility of Silver
      </div>

      <div className=" container mx-auto grid grid-cols-3 gap-4">
        <img className="image" src={dg1} alt="img"></img>
        <img className="image" src={dg2} alt="img"></img>
        <img className="image" src={dg3} alt="img"></img>
      </div>

      {/* End of section1 */}

      <div className="flex justify-center text-2xl font-semibold my-7">
        Revel in the Beauty of Classic Jewellery
      </div>

      <div className="container mx-auto  grid grid-cols-2 gap-4">
        <img className="image" src={dg4} alt="img"></img>
        <div className="grid grid-cols-2 grid-rows-2 gap-2">
          <img className="image" src={dg5} alt="img"></img>
          <img className="image" src={dg6} alt="img"></img>
          <img className="image" src={dg7} alt="img"></img>
          <img className="image" src={dg8} alt="img"></img>
        </div>
      </div>

      {/* End of section2 */}

      <div className="flex justify-center text-2xl font-semibold my-7">
        The Cultural Significance of Silver
      </div>

      <div className="container mx-auto flex justify-center">
        <img className="image" src={dg9} alt="img"></img>
      </div>

      {/* End of section3 */}

      <div className="flex justify-center text-xl font-semibold my-7">
        The Enduring Allure of Silver
      </div>

      <div className=" container mx-auto grid grid-cols-3 gap-4">
        <img className="image" src={dg10} alt="img"></img>
        <img className="image" src={dg11} alt="img"></img>
        <img className="image" src={dg12} alt="img"></img>
      </div>

      {/* End of section4 */}

      <div className="flex justify-center text-2xl font-semibold my-7">
        Crafting Dreams into Reality
      </div>

      <div className=" container mx-auto grid grid-cols-5 gap-4">
        <div className="justify-self-center">
          <img className="image" src={dg13} alt="img"></img>
          <p className=" flex justify-center font-semibold my-7 ">Earrings</p>
        </div>

        <div className="justify-self-center">
          <img className="image" src={dg14} alt="img"></img>
          <p className=" flex justify-center font-semibold my-7">Bangles</p>
        </div>

        <div className="justify-self-center">
          <img className="image" src={dg15} alt="img"></img>
          <p className=" flex justify-center font-semibold my-7">Toe Ring</p>
        </div>

        <div className="justify-self-center">
          <img className="image" src={dg16} alt="img"></img>
          <p className=" flex justify-center font-semibold my-7">Pendant</p>
        </div>

        <div className="justify-self-center">
          <img className="image" src={dg17} alt="img"></img>
          <p className=" flex justify-center font-semibold  my-7">Nose Pin</p>
        </div>
      </div>

      {/* End of section5 */}

      <div className=" container mx-auto grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="row-span-3">
          <img className="image " src={dg18} alt="" />
        </div>

        <img className="image" src={dg19} alt="" />
        <img className="image" src={dg20} alt="" />
        <img className="image" src={dg21} alt="" />
      </div>

      {/* End of section6 */}
      <div className="bg-divine_primary w-full mt-5">
        <div className="container mx-auto py-4">
          <div className="grid grid-cols-2 gap-8">
            <article className="text-white flex items-center space-x-4">
              <div className="flex items-center justify-center border border-slate-50 rounded-full bg-slate-50 w-10 h-10">
                <FaBell className="text-black" />
              </div>
              <div>
                <h3>SUBSCRIBE TO OUR NEWSLETTER</h3>
                <p>
                  Get all the latest information on Events, Sales and Offers.
                </p>
              </div>
            </article>

            <form className="flex items-center">
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email"
                className="w-full px-3 py-2 border rounded-lg mr-2"
              ></input>
              <button
                type="submit"
                className="bg-divine_secondary text-black font-semibold px-4 py-2 rounded-lg"
              >
                <span>SUBSCRIBE</span>
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="bg-divine_secondary grid grid-cols-3 gap-4 ">
        <div className="flex justify-center">
          <img className="image w-64 h-24  " src={logo} alt="img"></img>
        </div>

        <div>
          <h2 className="my-4 text-black font-semibold">GET US HELP YOU</h2>
          <ul className="list-none p-0 m-0">
            <li className="py-2 ">Contact Us</li>
            <li className="py-2">Terms and Condition</li>
            <li className="py-2">FAQ</li>
          </ul>
        </div>

        <div>
          <h2 className="my-4 text-black font-semibold">OUR POLICIES</h2>
          <ul className="list-none p-0 m-0 ">
            <li className="py-2 ">Privacy Policy</li>
            <li className="py-2">Shipping Policy</li>
            <li className="py-2 ">Cancellation Policy</li>
            <li className="py-2 ">Exchange Policy</li>
          </ul>
        </div>
      </div>

      <div className=" bg-divine_primary ">
        <div className="container mx-auto text-white">
          ⓒ All rights reserved
        </div>
      </div>

      {/* End of footer section */}
    </>
  );
};

export default DivineGrace;
